import { render, staticRenderFns } from "./BusInspectionWorkshopGroupList.vue?vue&type=template&id=5fedb804&scoped=true&"
import script from "./BusInspectionWorkshopGroupList.vue?vue&type=script&lang=js&"
export * from "./BusInspectionWorkshopGroupList.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionWorkshopGroupList.vue?vue&type=style&index=0&id=5fedb804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fedb804",
  null
  
)

export default component.exports